import React, { useEffect } from 'react';
import { useRef } from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';

const StoreTotalsComponent = props => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null); // To keep a reference to the chart instance

  useEffect(() => {
    // Initialize the chart only once
    chartInstance.current = am4core.create(
      chartRef.current,
      am4charts.PieChart,
    );
    chartInstance.current.hiddenState.properties.opacity = 0; // Initial fade-in effect

    // Create pie series
    const pieSeries = chartInstance.current.series.push(
      new am4charts.PieSeries(),
    );
    pieSeries.dataFields.value = 'value';
    pieSeries.dataFields.category = 'store';

    // Add tooltips
    pieSeries.slices.template.tooltipText = '{category}: {value}';

    // Style labels with Tailwind classes
    pieSeries.labels.template.adapter.add('html', function (html, target) {
      const category = target.dataItem?.category || '';
      const value = target.dataItem?.value || '';
      return `<span class="text-white font-semibold">${category}: ${value}</span>`;
    });

    // Cleanup on unmount
    return () => {
      chartInstance.current.dispose();
      chartInstance.current = null;
    };
  }, []); // Empty dependency array ensures this runs only once

  useEffect(() => {
    if (chartInstance.current) {
      // Update the chart data whenever props.totalPricesPerStore changes
      chartInstance.current.data = props.totalPricesPerStore.map(store => ({
        store: store.card_price_store,
        value: parseInt(store.count, 10),
      }));
    }
  }, [props.totalPricesPerStore]); // Update chart when props.totalPricesPerStore changes

  return (
    <div className="w-full">
      <div
        ref={chartRef}
        className="w-full h-[400px] sm:h-[500px] md:h-[600px] lg:h-[700px]"></div>
    </div>
  );
};

export default StoreTotalsComponent;
